import { defineMessages } from 'react-intl';

export default defineMessages({
  disableNotificationsTitle: {
    id: 'global_notifications_manage_popup_title_deactivate',
    defaultMessage: 'Disable notifications',
  },
  disableNotificationsConfirmation: {
    id: 'global_notifications_manage_text_confirm_deactivate_all',
    defaultMessage: 'You have deactivated all your email alerts',
  },
  disableNotificationsModalContent: {
    id: 'global_notifications_manage_popup_text_deactivate_all',
    defaultMessage: 'Are you sure you want to deactivate all email alerts?',
  },
});



// WEBPACK FOOTER //
// ./app/NotificationsManager/email/DisableNotifications/messages.js